import React, { useState, useEffect } from "react";
import axios from 'axios';

function EstadisticasPage() {
  const [estadisticas, setEstadisticas] = useState([]);
  const [errorMsg,     setErrorMsg]     = useState("");
  const [loading,      setLoading]      = useState(true);
  const API_URL = `${process.env.REACT_APP_API_URL}/api`;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API_URL}/busqueda/estadisticas`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setEstadisticas(res.data);
      } catch (error) {
        if (error.response?.status === 403) {
          setErrorMsg("🚫 No tienes permisos para ver las estadísticas.");
        } else {
          setErrorMsg("❌ Error al cargar estadísticas.");
        }
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) return <p style={{ textAlign: "center", marginTop: 40 }}>Cargando estadísticas...</p>;

  return (
    <div style={st.container}>
      <h2>📊 Estadísticas de Búsquedas</h2>

      {errorMsg && <p style={{ color: "red" }}>{errorMsg}</p>}

      {!errorMsg && (
        estadisticas.length === 0 ? (
          <p style={{ color: "#888" }}>No hay búsquedas registradas.</p>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={st.tabla}>
              <thead>
                <tr style={st.thead}>
                  <th>#</th>
                  <th>Término de búsqueda</th>
                  <th>Total búsquedas</th>
                  <th>Porcentaje</th>
                </tr>
              </thead>
              <tbody>
                {estadisticas.map((e, i) => (
                  <tr key={i} style={st.fila}>
                    <td style={st.tdNum}>{i + 1}</td>
                    <td><strong>{e.terminoBusqueda}</strong></td>
                    <td style={st.tdNum}>{e.totalBusquedas}</td>
                    <td>
                      <div style={st.barraContainer}>
                        <div style={{ ...st.barra, width: `${Math.min(e.porcentaje, 100)}%` }} />
                        <span style={st.pct}>{Math.round(e.porcentaje)}%</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
}

const st = {
  container: { padding: "24px 16px", maxWidth: 800, margin: "0 auto" },
  tabla: { width: "100%", borderCollapse: "collapse", fontSize: 13 },
  thead: { backgroundColor: "#1a1a2e", color: "#fff" },
  fila:  { borderBottom: "1px solid #e5e7eb" },
  tdNum: { textAlign: "center", color: "#666", width: 60 },
  barraContainer: { display: "flex", alignItems: "center", gap: 8 },
  barra: {
    height: 10, backgroundColor: "#1a1a2e", borderRadius: 4,
    transition: "width 0.3s ease", minWidth: 4,
  },
  pct: { fontSize: 12, color: "#555", whiteSpace: "nowrap" },
};

// Estilos de celdas
const styleEl = document.createElement("style");
styleEl.textContent = `
  #estadisticas-tabla td, #estadisticas-tabla th { padding: 10px 14px; text-align: left; }
  #estadisticas-tabla tbody tr:hover { background-color: #f8fafc; }
`;
document.head.appendChild(styleEl);

export default EstadisticasPage;
